import { Card, Separator } from '@repo/shadcn';
import { FC } from 'react';

import { formatCurrencyInBDT } from '@/utils';

import { LoadingSpinner } from '../../../components/loaders';
import { usePurchaseSummary } from './purchase-summary.hook';

export const PurchaseSummary: FC = () => {
    const { data, isError, isFetching, isLoading, error } =
        usePurchaseSummary();

    if (isLoading || isFetching) {
        return <LoadingSpinner />;
    }

    if (isError || !data || !data?.data) {
        return <ErrorComponent error={error} />;
    }

    return (
        <Card className="pt-3">
            <h2 className={'px-2 text-xl font-medium'}>Purchase Summary</h2>

            <div className={'font-xl mt-3 grid grid-cols-1 font-medium'}>
                <div className={'grid grid-cols-2 bg-gray-50 p-2'}>
                    <span>Total Purchase</span>
                    <span className={'block text-right'}>
                        {data?.data?.total_purchases || 0}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-white p-2'}>
                    <span>Total Purchase Amount</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(data?.data?.total_price || 0)}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-gray-50 p-2'}>
                    <span>Total Paid Amount</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(
                            data?.data?.total_paid_amount || 0,
                        )}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-white p-2'}>
                    <span>Total Due Amount</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(data?.data?.total_due_amount || 0)}
                    </span>
                </div>

                {/* <Separator /> */}
            </div>
        </Card>
    );
};

const ErrorComponent: FC<{ error: any }> = ({ error }) => {
    return (
        <Card className="pt-2">
            <h2 className={'px-2 text-xl font-medium'}>Sales Summary</h2>
            <div className={'font-xl mt-4 grid grid-cols-1 font-medium'}>
                <p className="text-red-500">Failed to load sales summary.</p>
                <p className="text-red-500">
                    {error?.message || 'Unknown error'}
                </p>
            </div>
        </Card>
    );
};
